/**
 * Created by liuchuanyang on 2018/8/27.
 */
// import common from '../../utils/common';
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            title_: "",
            noHeader: false,
            pageTitle: "",

            // form var
            formCode: null,
            viewCode: null,
            formId: null,
            viewId: null,
            menuId: null,
            queryParam: {}
        }
    },
    computed: {
        isMainMenu() {
            return false;
        },
        isValidForm() {
            return this.formCode || this.formId || this.menuId;
        },
        ...mapState([
            'project'
        ])
    },
    mounted() {
        this.initCommon();
    },
    watch: {
        '$route' (to, from) {
            this.initCommon();
        },
        pageTitle() {
            this.handleSetTitle();
        }
    },
    methods: {
        initCommon() {
            this.formCode = this.$route.query._fc;
            this.viewCode = this.$route.query._vc;
            this.formId   = this.$route.query._fi;
            this.viewId   = this.$route.query._vi;
            this.menuId   = this.$route.query._mi;

            let _title = this.$route.query._title;
            let _nh = this.$route.query._nh;

            if(_title) this.title_ = _title;
            if(_nh === 1 || _nh === "1" || _nh === true || _nh === "true") {
                this.noHeader = true;
            } else {
                this.noHeader = false;
            }

            this.handlePageReady();
            this.handleSetTitle();
        },
        handleSetTitle() {
            let title = this.pageTitle;
            let projectName = _.get(this.project, "project_name");

            if(projectName) {
                if(title) {
                    title = `${ title } - ${ projectName }`;
                } else {
                    title = projectName;
                }
            }
            this.$utils.setTitle(title);
        },
        handlePageReady(info) {
            let page = _.get(info, 'page');
            let form = _.get(info, 'form');
            let menu = _.get(info, 'menu');

            let name =  _.get(menu, 'content_name') || _.get(this.menu, 'content_name');

            if(!name) name = _.get(page, "page_name");
            if(!name) name = _.get(form, "view_name") || _.get(form, "form_view_name");
            if(!name) name = _.get(form, "form_name");

            let pageTitle = "";

            if(this.title_) {
                pageTitle = decodeURIComponent(this.title_);
            } else if(name) {
                pageTitle = name;
            }

            if(pageTitle) this.pageTitle = pageTitle;

            let kvs1 = this.$utils.getQueryParam(window.location.search);
            let kvs2 = this.$utils.getQueryParam(window.location.hash);

            this.queryParam = _.extend(kvs1, kvs2);
        }
    }
};
